import { Box, Text, SimpleGrid, Flex, Button } from '@chakra-ui/react'
import { Upload, CheckCircle } from 'lucide-react'
import { useAccountingContext } from '../../context/AccountingContext'
import { BankAccountsList } from '@/features/banking/components/BankAccountsList'

export function BankTab() {
  const { residenceId } = useAccountingContext()

  return (
    <Box>
      {/* Comptes bancaires */}
      <Box mb={6}>
        <BankAccountsList residenceId={residenceId} />
      </Box>

      <SimpleGrid columns={{ base: 1, lg: 2 }} gap={6}>
        {/* Import relevés */}
        <Box bg="white" p={5} borderRadius="lg" boxShadow="sm">
          <Flex justify="space-between" align="center" mb={4}>
            <Text fontSize="lg" fontWeight="semibold">Import de relevés</Text>
          </Flex>

          <Box textAlign="center" py={8} color="gray.500">
            <Upload size={40} style={{ margin: '0 auto 12px' }} />
            <Text>Import automatique des relevés bancaires</Text>
            <Text fontSize="sm" mt={2}>
              Formats supportés: CSV, OFX, QIF (bientôt disponible)
            </Text>
          </Box>
        </Box>

        {/* Rapprochement bancaire */}
        <Box bg="white" p={5} borderRadius="lg" boxShadow="sm">
          <Flex justify="space-between" align="center" mb={4}>
            <Text fontSize="lg" fontWeight="semibold">Rapprochement bancaire</Text>
            <Button colorPalette="brand" size="sm" disabled>
              <CheckCircle size={16} />
              Nouveau rapprochement
            </Button>
          </Flex>

          <Box textAlign="center" py={8} color="gray.500">
            <CheckCircle size={40} style={{ margin: '0 auto 12px' }} />
            <Text>Rapprochez vos relevés bancaires avec vos écritures</Text>
            <Text fontSize="sm" mt={2}>
              Fonctionnalité disponible prochainement
            </Text>
          </Box>
        </Box>
      </SimpleGrid>
    </Box>
  )
}
